import { cellToBoundary, cellToLatLng } from 'h3-js'
import type { Position } from 'geojson'

export function cellToGeoJsonCoordinates(h3: string): Position {
  const [lat, lng] = cellToLatLng(h3) as [number, number]

  return [lng, lat]
}

export function cellToMapLatLngLiteral(h3: string) {
  const [lng, lat] = cellToGeoJsonCoordinates(h3)

  return {
    lat,
    lng,
  }
}

export function cellToGeoJsonPolygonRing(h3: string): Position[] {
  const boundary = cellToBoundary(h3) as [number, number][]
  const ring = boundary.map(([lat, lng]) => [lng, lat] as Position)

  return [...ring, ring[0]]
}
